/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { classNames } from '@ember-decorators/component';

@classNames('icon-picker')
export default class IconPicker extends Component {
  @action
  setFilterText(value) {
    this.filterText = value;
  }

  // Args
  isOpen = false;

  size = 24;
  @tracked selected = '';

  // State
  @tracked filterText = '';

  additionalIcons = [];

  @computed('icons.[]', 'additionalIcons.[]', 'filterText')
  get filteredIcons() {
    let filter = this.filterText;
    let icons = [...this.icons, ...this.additionalIcons];
    if (filter) {
      icons = icons.filter((icon) => {
        return icon.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
      });
    }
    return icons;
  }

  // displayIcon returns the icon to be displayed, providing safety guarantees
  // around initial null and undefined values.
  get displayIcon() {
    return isEmpty(this.selected) ? '' : this.selected;
  }

  icons = Object.freeze([
    'ac_unit',
    'access_alarm',
    'access_time',
    'accessibility',
    'accessible',
    'account_balance',
    'account_balance_wallet',
    'account_box',
    'account_circle',
    'adb',
    'add',
    'add_a_photo',
    'add_alarm',
    'add_alert',
    'add_box',
    'add_circle',
    'add_circle_outline',
    'add_location',
    'add_shopping_cart',
    'add_to_photos',
    'add_to_queue',
    'address_book',
    'address_card',
    'adjust',
    'agenda',
    'airplanemode_active',
    'airplay',
    'airport_shuttle',
    'alarm_on',
    'album',
    'all_inclusive',
    'all_out',
    'android',
    'announcement',
    'apps',
    'archive',
    'archive',
    'art_track',
    'ask',
    'aspect_ratio',
    'assessment',
    'assignment',
    'assignment_ind',
    'assignment_late',
    'assignment_return',
    'assignment_returned',
    'assignment_turned_in',
    'assistant',
    'assistant_photo',
    'assistive_listening_systems',
    'attach_file',
    'attach_money',
    'attachment',
    'audiotrack',
    'autorenew',
    'av_timer',
    'backspace',
    'backup',
    'badge',
    'banknote',
    'basket',
    'battery_alert',
    'battery_charging_full',
    'battery_full',
    'battery_unknown',
    'beach_access',
    'beenhere',
    'bluetooth',
    'book',
    'bookmark',
    'bookmark_3',
    'bookmark_border',
    'bookmarks',
    'border_all',
    'border_clear',
    'border_color',
    'brain',
    'branding_watermark',
    'brightness_1',
    'brightness_3',
    'brightness_5',
    'brightness_6',
    'brightness_7',
    'broken_image',
    'brush',
    'bubble',
    'bubble_2',
    'bubble_chart',
    'bubbles',
    'bug',
    'bug_report',
    'build',
    'bullhorn',
    'burst_mode',
    'business',
    'business_center',
    'cached',
    'cake',
    'call',
    'call_made',
    'call_merge',
    'call_missed',
    'call_missed_outgoing',
    'call_received',
    'call_split',
    'call_to_action',
    'camera',
    'camera_alt',
    'camera_roll',
    'cancel',
    'card_giftcard',
    'card_membership',
    'card_travel',
    'casino',
    'cast',
    'cast_connected',
    'center_focus_strong',
    'center_focus_weak',
    'change_history',
    'chart',
    'chat',
    'chat_bubble',
    'chat_bubble_outline',
    'chat2',
    'check',
    'check_box',
    'check_box_outline_blank',
    'check_circle',
    'checkmark',
    'checkmark_2',
    'checkmark_3',
    'chess',
    'chevron_left',
    'chevron_right',
    'child_care',
    'child_friendly',
    'chrome_reader_mode',
    'clear',
    'clear_all',
    'clock',
    'close_2',
    'close_2_outline',
    'cloud',
    'cloud_circle',
    'cloud_done',
    'cloud_download',
    'cloud_queue',
    'code',
    'cogs',
    'collections',
    'collections_bookmark',
    'color_lens',
    'colorize',
    'comment',
    'compare',
    'compare_arrows',
    'computer',
    'cone',
    'confirmation_number',
    'contact_mail',
    'contact_phone',
    'contacts',
    'content_copy',
    'content_cut',
    'content_paste',
    'control_point_duplicate',
    'copy',
    'copyright',
    'create',
    'create_new_folder',
    'credit_card',
    'crop',
    'crop_free',
    'crop_original',
    'crop_rotate',
    'cross',
    'dashboard',
    'data_usage',
    'date_range',
    'deaf',
    'dehaze',
    'delete',
    'delete_forever',
    'delete_sweep',
    'description',
    'desktop_windows',
    'details',
    'developer_board',
    'developer_mode',
    'device_hub',
    'devices',
    'devices_other',
    'dialpad',
    'directions',
    'directions_bike',
    'directions_boat',
    'directions_bus',
    'directions_car',
    'directions_railway',
    'directions_run',
    'directions_subway',
    'directions_walk',
    'disc_full',
    'dns',
    'do_not_disturb',
    'do_not_disturb_alt',
    'do_not_disturb_on',
    'dock',
    'done_all',
    'donut_large',
    'donut_small',
    'download',
    'download2',
    'drafts',
    'drag_handle',
    'drive_eta',
    'edit_location',
    'eject',
    'email',
    'enhanced_encryption',
    'enlarge',
    'equalizer',
    'error',
    'error_outline',
    'ev_station',
    'event',
    'event_available',
    'event_busy',
    'event_note',
    'event_seat',
    'exit',
    'exit_to_app',
    'expand_less',
    'expand_more',
    'explore',
    'exposure',
    'exposure_neg_1',
    'exposure_neg_2',
    'exposure_plus_1',
    'exposure_plus_2',
    'exposure_zero',
    'extension',
    'eye_blocked',
    'face',
    'fast_forward',
    'fast_rewind',
    'favorite',
    'favorite_border',
    'featured_play_list',
    'featured_video',
    'feedback',
    'fiber_manual_record',
    'fiber_new',
    'file_css',
    'file_download',
    'file_excel',
    'file_pdf',
    'file_spreadsheet',
    'file_upload',
    'file_word',
    'film',
    'filter',
    'filter_1',
    'filter_2',
    'filter_3',
    'filter_4',
    'filter_5',
    'filter_6',
    'filter_7',
    'filter_8',
    'filter_9',
    'filter_9_plus',
    'filter_b_and_w',
    'filter_center_focus',
    'filter_drama',
    'filter_frames',
    'filter_hdr',
    'filter_list',
    'filter_none',
    'filter_tilt_shift',
    'filter_vintage',
    'find_in_page',
    'find_replace',
    'fingerprint',
    'first_page',
    'fitness_center',
    'flag',
    'flare',
    'flash_on',
    'flight_land',
    'flip',
    'folder',
    'folder_open',
    'folder_shared',
    'folder_special',
    'font_download',
    'forum',
    'forward',
    'free_breakfast',
    'fullscreen',
    'fullscreen_exit',
    'functions',
    'g_translate',
    'gamepad',
    'gavel',
    'gesture',
    'gif',
    'goat',
    'golf_course',
    'gps_fixed',
    'gps_not_fixed',
    'grade',
    'gradient',
    'grain',
    'graphic_eq',
    'grid',
    'grid_on',
    'group',
    'group_add',
    'group_work',
    'growth',
    'guitar',
    'hand',
    'hand_paper_o',
    'happy',
    'happy_2',
    'hdr_strong',
    'hdr_weak',
    'headset',
    'headset_mic',
    'healing',
    'hearing',
    'heart_2',
    'help',
    'help_outline',
    'help2',
    'highlight',
    'history',
    'home',
    'hot_tub',
    'hotel',
    'hourglass_empty',
    'hourglass_full',
    'https',
    'image',
    'image_aspect_ratio',
    'import_contacts',
    'import_export',
    'important_devices',
    'inbox',
    'indeterminate_check_box',
    'infinite',
    'info_outline',
    'input',
    'inquiry',
    'insert_comment',
    'insert_drive_file',
    'insert_emoticon',
    'insert_link',
    'invert_colors',
    'iso',
    'kete',
    'kete3',
    'key',
    'kitchen',
    'koru',
    'label',
    'label_outline',
    'language',
    'laptop_chromebook',
    'last_page',
    'launch',
    'layers',
    'layers_clear',
    'leak_add',
    'leak_remove',
    'lens',
    'library_books',
    'library_music',
    'lightbulb_outline',
    'line_style',
    'line_weight',
    'linear_scale',
    'linked_camera',
    'list',
    'list2',
    'live_help',
    'live_tv',
    'local_activity',
    'local_airport',
    'local_atm',
    'local_bar',
    'local_cafe',
    'local_car_wash',
    'local_convenience_store',
    'local_dining',
    'local_drink',
    'local_florist',
    'local_grocery_store',
    'local_hospital',
    'local_laundry_service',
    'local_library',
    'local_mall',
    'local_movies',
    'local_offer',
    'local_pharmacy',
    'local_pizza',
    'local_shipping',
    'local_taxi',
    'looks',
    'looks_3',
    'looks_4',
    'looks_5',
    'looks_6',
    'looks_one',
    'looks_two',
    'loop',
    'loupe',
    'low_priority',
    'loyalty',
    'magazine',
    'mail_outline',
    'map',
    'marker',
    'markunread_mailbox',
    'memory',
    'menu',
    'message',
    'mic',
    'minutes',
    'mode_comment',
    'monetization_on',
    'monochrome_photos',
    'mood_bad',
    'more',
    'motorcycle',
    'mouse',
    'move',
    'move_to_inbox',
    'movie',
    'movie_filter',
    'multiline_chart',
    'music',
    'music_note',
    'music_video',
    'nature',
    'nature_people',
    'navigation',
    'near_me',
    'network_cell',
    'network_check',
    'network_locked',
    'network_wifi',
    'new_releases',
    'new_tab',
    'newspaper',
    'next_week',
    'nfc',
    'no_encryption',
    'no_sim',
    'note',
    'note_add',
    'notifications',
    'notifications_active',
    'notifications_none',
    'notifications_paused',
    'ondemand_video',
    'opacity',
    'open_in_browser',
    'open_with',
    'pages',
    'pageview',
    'pan_tool',
    'panorama',
    'panorama_fish_eye',
    'panorama_horizontal',
    'panorama_vertical',
    'panorama_wide_angle',
    'paperclip',
    'party_mode',
    'pause',
    'pause_circle_filled',
    'pause_circle_outline',
    'people_outline',
    'perm_camera_mic',
    'perm_contact_calendar',
    'perm_data_setting',
    'perm_device_information',
    'perm_identity',
    'perm_media',
    'perm_phone_msg',
    'perm_scan_wifi',
    'person',
    'person_add',
    'person_pin',
    'person_pin_circle',
    'person2',
    'pets',
    'phone_android',
    'phone_in_talk',
    'phone_iphone',
    'phone_missed',
    'phonelink_erase',
    'phonelink_lock',
    'phonelink_ring',
    'phonelink_setup',
    'photo_album',
    'photo_filter',
    'photo_size_select_actual',
    'photo_size_select_large',
    'photo_size_select_small',
    'picture_as_pdf',
    'picture_in_picture',
    'picture_in_picture_alt',
    'pie',
    'pie_chart',
    'pie_chart_outlined',
    'pin_drop',
    'play_arrow',
    'play_circle_filled',
    'play_circle_outline',
    'play_for_work',
    'playlist_add',
    'playlist_add_check',
    'playlist_play',
    'plus_one',
    'point_down',
    'polymer',
    'pool',
    'portrait',
    'power',
    'power_input',
    'power_settings_new',
    'pregnant_woman',
    'present_to_all',
    'priority_high',
    'public',
    'publish',
    'puzzle',
    'qr_code',
    'queue_music',
    'queue_play_next',
    'radio',
    'radio_button_checked',
    'radio_unchecked',
    'rate_review',
    'reading',
    'receipt',
    'recent_actors',
    'record_voice_over',
    'redo',
    'refresh',
    'remove',
    'remove_circle_outline',
    'remove_from_queue',
    'remove_red_eye',
    'remove_shopping_cart',
    'reorder',
    'repeat',
    'repeat_one',
    'replay',
    'reply',
    'reply_all',
    'report',
    'report_problem',
    'restaurant',
    'restore_page',
    'retweet',
    'ring_volume',
    'road',
    'rocket',
    'room_service',
    'rotate_90_degrees_ccw',
    'rotate_left',
    'rotate_right',
    'rounded_corner',
    'router',
    'rowing',
    'rss_feed',
    'rv_hookup',
    'satellite',
    'save',
    'scales',
    'scanner',
    'school',
    'screen_share',
    'sd_card',
    'search',
    'security',
    'select_all',
    'send',
    'sentiment_dissatisfied',
    'sentiment_neutral',
    'sentiment_satisfied',
    'sentiment_very_dissatisfied',
    'sentiment_very_satisfied',
    'settings',
    'settings_backup_restore',
    'settings_bluetooth',
    'settings_brightness',
    'settings_cell',
    'settings_ethernet',
    'settings_input_antenna',
    'settings_input_component',
    'settings_input_hdmi',
    'settings_input_svideo',
    'settings_overscan',
    'settings_remote',
    'settings_system_daydream',
    'share',
    'shop',
    'shop_two',
    'shopping_basket',
    'shopping_basket_2',
    'short_text',
    'show_chart',
    'shuffle',
    'signal_cellular_4_bar',
    'signal_cellular_connected_no_internet_4_bar',
    'signal_cellular_null',
    'signal_wifi_4_bar',
    'signal_wifi_4_bar_lock',
    'skip_next',
    'skip_previous',
    'slideshow',
    'slow_motion_video',
    'smartphone',
    'sms',
    'snooze',
    'soccer',
    'sort',
    'sort_amount_desc',
    'sort_by_alpha',
    'sort2',
    'spa',
    'space_bar',
    'speaker',
    'speaker_group',
    'speaker_notes',
    'speaker_phone',
    'spellcheck',
    'stack',
    'stackoverflow',
    'star_3',
    'star_border',
    'star_half',
    'stars',
    'stay_current_landscape',
    'stop',
    'stop_screen_share',
    'storage',
    'store',
    'straighten',
    'streetview',
    'strikethrough_s',
    'style',
    'subject',
    'subscriptions',
    'subtitles',
    'subway',
    'supervisor_account',
    'surround_sound',
    'swap_calls',
    'swap_horiz',
    'swap_vert',
    'swap_vertical_circle',
    'switch',
    'switch_camera',
    'switch_video',
    'sync_disabled',
    'sync_problem',
    'system_update',
    'system_update_alt',
    'tab',
    'tab_unselected',
    'tablet',
    'tablet_android',
    'tags',
    'tags_2',
    'tap_and_play',
    'target',
    'text_fields',
    'text_format',
    'texture',
    'thumb_down',
    'thumb_up',
    'thumbs_up_down',
    'timelapse',
    'timeline',
    'timer',
    'title',
    'toc',
    'today',
    'toll',
    'tonality',
    'tools',
    'touch_app',
    'toys',
    'track_changes',
    'traffic',
    'train',
    'tram',
    'transfer_within_a_station',
    'transform',
    'translate',
    'trending_down',
    'trending_flat',
    'trending_up',
    'tune',
    'tv',
    'unarchive',
    'undo',
    'unfold_less',
    'unfold_more',
    'unlocked',
    'update',
    'upload',
    'usb',
    'use',
    'verified_user',
    'vertical_align_bottom',
    'vertical_align_center',
    'vertical_align_top',
    'vibration',
    'video_call',
    'video_label',
    'video_library',
    'videocam',
    'videogame_asset',
    'view_agenda',
    'view_array',
    'view_carousel',
    'view_column',
    'view_comfy',
    'view_compact',
    'view_day',
    'view_headline',
    'view_list',
    'view_module',
    'view_quilt',
    'view_stream',
    'view_week',
    'vignette',
    'voice_chat',
    'voicemail',
    'volume_down',
    'volume_mute',
    'volume_up',
    'vpn_key',
    'vpn_lock',
    'wallpaper',
    'wand',
    'warning_2',
    'warning_2_outline',
    'watch',
    'watch_later',
    'wb_incandescent',
    'wb_sunny',
    'wc',
    'web',
    'web_asset',
    'weekend',
    'whatshot',
    'widgets',
    'wifi',
    'wifi_lock',
    'wifi_tethering',
    'work',
    'work2',
    'wrap_text',
    'youtube_searched_for',
    'zoom_in',
    'zoom_out',
    'zoom_out_map',
  ]);
}
